var map = {
	"./Laskupainikkeet_Erämaksu.png": 422,
	"./Laskupainikkeet_Lasku.png": 423,
	"./Laskupainikkeet_Yrityslasku.png": 424,
	"./Neste-logo.svg": 425,
	"./PÖ-fi-background-Edge.jpg": 426,
	"./PÖfi-logo.svg": 120,
	"./St1-logo.svg": 427,
	"./Teboil-logo.svg": 428,
	"./forest_background.png": 429,
	"./hamburger-icon.jpeg": 430,
	"./home-background.jpg": 431,
	"./menu-icon.svg": 432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 421;